import React, { useMemo } from 'react';

import TableCDS from 'app/shared/componentsRestyled/coreDesignSystem/Table/TableCDS';
import PropTypes from 'prop-types';

import { VendorRequestsTestIds } from '../vendorRequests.testIds';

import { vendorRequestsTableConfig } from './VendorRequestsTable.config';
import { EMPTY_MESSAGE_TEXT, NO_FILTER_MATCH_MESSAGE_TEXT } from './VendorRequestsTable.constants';

const VendorRequestsTable = ({
  hasActiveFilters,
  isLoading,
  items,
  onPageChange,
  onRowClick,
  onRowsPerPageChange,
  page,
  rowsPerPage,
  totalCount,
}) => {
  const noAvailableMessageText = hasActiveFilters
    ? NO_FILTER_MATCH_MESSAGE_TEXT
    : EMPTY_MESSAGE_TEXT;

  const paginationProps = useMemo(
    () => ({
      count: totalCount,
      onPageChange,
      onRowsPerPageChange,
      page,
      rowsPerPage,
    }),
    [onPageChange, onRowsPerPageChange, page, rowsPerPage, totalCount],
  );

  return (
    <TableCDS
      withNoAvailableMessage
      config={vendorRequestsTableConfig}
      data={items}
      isLoading={isLoading}
      noAvailableMessageText={noAvailableMessageText}
      paginationProps={paginationProps}
      rowTestId={VendorRequestsTestIds.GROUP_ROW}
      onRowClick={onRowClick}
    />
  );
};

VendorRequestsTable.propTypes = {
  hasActiveFilters: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRowClick: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
};

export default VendorRequestsTable;
